let navigationFunction;

export const setNavigate = (navigate) => {
    navigationFunction = navigate;
}

export const navigateTo = (path, options = {}) => {
    if (navigationFunction) {
        navigationFunction(path, options)
    } else {
        console.log("Navigation function is not initialized");
    }
}